import React, { Component } from 'react'
import { connect } from 'react-redux'
import { TagActions } from 'actionsets'
import { Link } from 'react-router-dom'
import Dependent from 'containers/shared/Dependent'
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography'
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import EditIcon from '@material-ui/icons/Edit'
import IconButton from '@material-ui/core/IconButton'

export class Show extends Component{

  constructor(props){
    super(props)
    TagActions.bindActions(this)
  }

  dependsOn(){
    return this.actions.show(this.id)
  }

  dependenciesMet(){
    return !!this.tag.id
  }

  get id(){
    return this.props.match.params.id
  }

  get tag(){
    return this.props.tag
  }

  render = () =>
    <Card>
      <CardContent>
        <Typography variant='h4'>Tag - {this.tag.name}</Typography>
        <Table>
          <TableBody>
            <TableRow>
              <TableCell style={{width: 30}} variant='head'>Actions</TableCell>
              <TableCell>
                <Link to={`/tags/${this.tag.id}/edit`}>
                  <IconButton>
                    <EditIcon/>
                  </IconButton>
                </Link>
              </TableCell>
            </TableRow>
              <TableRow>
                <TableCell variant='head'>Label</TableCell>
                <TableCell>{String(this.tag.label)}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell variant='head'>Item</TableCell>
                <TableCell>{String(this.tag.itemId)}</TableCell>
              </TableRow>
          </TableBody>
        </Table>
        <br/>
      </CardContent>
    </Card>
}


export default connect(({tags}) => tags)(Dependent({loader: true, clearOnLoad: true})(Show))